/**
 * OspitePage - Page Shell
 * Redirect al database ospiti
 */

import { useEffect } from "react";

export default function OspitePage() {
  useEffect(() => {
    window.location.href = "/ospiti/database";
  }, []);
  return null;
}
